<template>
    <b-form @submit.stop.prevent="checkIDNo"
            class="px-3">
        <Stepper :steps="steps"
                 :step="step" />
        <div class="px-3">
            <p class="font-size">請先填寫您的身分證字號，以利預約您的富邦人壽業務夥伴</p>
            <b-row class="px-2 mb-2 align-items-center">
                <b-col class="px-0"
                       sm="3">
                       <div class="text-nowrap pr-3 font-weight-bold font-size">身分證字號</div>
                </b-col>

                <b-col class="px-0"
                       sm="9">
                       <b-form-input :value="form.idNo"
                                  autocomplete="off"
                                  :state="validateState('idNo')"
                                  @change="changeIdNo"
                                  maxLength="10"
                                  placeholder="請輸入身分證字號"
                                  :disabled="!edit || loading"></b-form-input>
                </b-col>
            </b-row>
            <b-row class="mx-0 mb-1">
                <b-col cols="12"
                       class="px-0"
                       sm="3"></b-col>
                <b-col cols="12"
                       class="px-0"
                       sm="9">
                    <div class="error text-left"
                     v-if="$v.form.idNo.$dirty&&!$v.form.idNo.required">請輸入身分證號碼</div>
                    <div class="error text-left"
                     v-if="$v.form.idNo.required&&$v.form.idNo.$dirty&&!$v.form.idNo.idNoPattern">身分證號碼格式錯誤，請重新輸入</div>
                </b-col>
            </b-row>
            <b-row class="px-2 mb-3 align-items-center">
                <b-col class="px-0"
                       sm="3">
                       <div class="text-nowrap pr-3 font-weight-bold font-size">生日</div>
                </b-col>
                <b-col class="px-0"
                       sm="0.5">
                    民國
                </b-col>
                <b-col class="px-0"
                       sm="3">
                    <Select
                        :cid="'year'"
                        v-model.trim="$v.form.year.$model"
                        :state="validateState('year')"
                        :options="years" />
                </b-col>
                <b-col class="px-0"
                       sm="0.4">
                    年
                </b-col>
                <b-col class="px-0"
                       sm="2">
                    <Select
                        :cid="'month'"
                        v-model.trim="$v.form.month.$model"
                        :state="validateState('month')"
                        :options="months" />
                </b-col>
                <b-col class="px-0"
                       sm="0.4">
                    月
                </b-col>
                <b-col class="px-0"
                       sm="2">
                    <Select
                        :cid="'day'"
                        v-model.trim="$v.form.day.$model"
                        :state="validateState('day')"
                        :options="days" />
                </b-col>
                <b-col class="px-0"
                       sm="0.4">
                    日
                </b-col>
            </b-row>
            <p class="text-danger"
               v-if="error">
                請再次確認您輸入資料是否有誤，或預約一位新的業務夥伴。
            </p>
            <Back :show="true" />
        </div>
        <div class="d-flex flex-row justify-content-around align-items-center my-5">
            <b-button pill
                      variant="primary"
                      class="button"
                      data-ga-element="新保險網站_原業務認證身分_下一步"
                      v-if="!error"
                      :disabled="loading"
                      type="submit">{{loading?'驗證中 ...':'下一步'}}</b-button>
            <b-button pill
                      variant="outline-primary"
                      class="button"
                      data-ga-element="新保險網站_原業務認證身分_幫我預約新夥伴"
                      v-if="error"
                      v-on:click="changeAnother">幫我預約新夥伴</b-button>
            <b-button pill
                      variant="primary"
                      class="button"
                      data-ga-element="新保險網站_原業務認證身分_重新驗證並下一步"
                      v-if="error"
                      :disabled="loading"
                      type="submit">{{loading?'驗證中 ...':'重新驗證並下一步'}}</b-button>
        </div>
        <Banner :srcId="this.srcId" />
        <Modal :show="show"
               :description="errorMessage"
               @onClose="onClose">
            <div slot="action"
                 class="d-flex justify-content-center align-items-center my-5">
                <b-button pill
                          variant="primary"
                          class="button"
                          v-on:click="onClose">確認</b-button>
            </div>
        </Modal>
    </b-form>
</template>

<script>
// @ is an alias to /src
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import Stepper from '@/components/Stepper.vue';
import Select from '@/components/Select.vue';
import Banner from '@/components/Banner.vue';
import Back from '@/components/Back.vue';
import { request } from '@/service';
import Modal from '@/components/Modal.vue';

const idNoPattern = (value) => {
    const pattern = /^[A-Za-z][12]\d{8}$/;
    return pattern.test(value);
};

export default {
    mixins: [validationMixin],
    name: 'IdNoVerification',
    components: {
        Stepper,
        Select,
        Banner,
        Back,
        Modal
    },
    beforeRouteEnter(to, from, next) {
        if (from.name !== 'FormData') {
            next();
        } else {
            next({ name: 'Home' });
        }
    },
    created() {
        this.$store.dispatch('setSubHeaderShow', true);
        this.getIDNo();
    },
    data() {
        return {
            loading: false,
            step: 1,
            steps: ['選擇身分', '認證身分', '填寫資料'],
            edit: true,
            error: false,
            success: false, // 串畫面使用,之後請刪除
            idNo: '',
            form: {
                idNo: '',
                year: '',
                month: '',
                day: '',
            },
            show: false,
            errorMessage: '',
            srcId: ''
        };
    },

    methods: {
        changeIdNo(value) {
            this.form.idNo = value;
            this.$v.form.idNo.$touch();
        },
        getIDNo() {
            this.$store.dispatch('getTokenInfo').then(response => {
                this.srcId = response.data.srcId;
                // 是否為網投登入頁進來
                if (response.data.isDirtLogin) {
                    // 如果是則將身分帳號碼帶入, 並不得修改
                    this.form.idNo = response.data.idNo;
                    this.edit = false;
                } else {
                    this.edit = true;
                }
            }).catch(error => {
                if (error.status === 401) {
                    this.errorMessage = error.message;
                    this.show = true;
                } else {
                    this.$notify({
                        group: 'alert',
                        title: '發生錯誤',
                        type: 'error',
                    });
                }
            });
        },
        onClose() {
            this.show = false;
            const protocol = window.location.protocol;
            const host = window.location.host;
            window.location.href = `${protocol}//${host}/fubonagent/`;
        },
        checkIDNo() {
            this.$v.form.$touch();
            if (this.$v.form.$anyError) {
                return;
            }
            this.loading = true;
            // 確認身分證號碼
            request({
                method: 'POST',
                api: '/auth/isExistCustomer',
                data: {
                    customerId: this.form.idNo,
                    year: this.form.year,
                    month: this.form.month,
                    day: this.form.day
                },
                secure: true
            })
                .then(res => {
                    this.loading = false;
                    if (res.data.isExistCustomer) {
                        this.error = false;
                        this.$router.push({ name: 'FormData' });
                    } else {
                        this.error = true;
                    }
                }).catch(e => {
                    this.loading = false;
                    if (e.status === 400) {
                        this.$notify({
                            group: 'alert',
                            title: e.data[0].error,
                            type: 'error',
                        });
                    } else if (e.status === 500) {
                        this.$notify({
                            group: 'alert',
                            title: e.message,
                            type: 'error',
                        });
                    }
                });
        },
        validateState(name) {
            const { $dirty, $error } = this.$v.form[name];
            return $dirty ? !$error : null;
        },
        changeAnother() {
            this.$store.dispatch('setNewFriend', true);
            this.$router.push({ name: 'FormData' });
        },
    },
    computed: {
        years() {
            var result = [];
            var length = 3;
            var today = new Date();
            for (var i = 1; i <= today.getFullYear() - 1911; i++) {
                var text = (Array(length).join('0') + i).slice(-length);
                result.push({ text: text, value: i });
            }
            return [{ text: '請選擇', value: '' }, ...result];
        },
        months() {
            var result = [];
            var length = 2;
            for (var i = 1; i <= 12; i++) {
                var text = (Array(length).join('0') + i).slice(-length);
                result.push({ text: text, value: i });
            }
            return [{ text: '請選擇', value: '' }, ...result];
        },
        days() {
            var result = [];
            var length = 2;
            for (var i = 1; i <= 31; i++) {
                var text = (Array(length).join('0') + i).slice(-length);
                result.push({ text: text, value: i });
            }
            return [{ text: '請選擇', value: '' }, ...result];
        },
    },
    validations: {
        form: {
            idNo: {
                required,
                idNoPattern
            },
            year: {
                required,
            },
            month: {
                required,
            },
            day: {
                required,
            }
        }
    }
};
</script>

<style scoped lang="scss">
.font-size {
    font-size: 1.125rem;
}
.spacing {
    margin-right: 90px;
}
</style>
